// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"453":"bc52fbf0","732":"12c97a6a","977":"e1d0a852"}[chunkId] + ".chunk.js");